import { Box, Chip, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

const nombreCompleto = (row) => {
  const apellido = row.apellido?.trim() || "";
  const nombre = row.nombrepila?.trim() || "";
  if (apellido && nombre) return `${apellido}, ${nombre}`;
  return apellido || nombre || "";
};

export const buildColumnsSinPedir = () => [
  {
    id: "empleado",
    header: "Empleado",
    accessorFn: (row) => nombreCompleto(row) || row.username || "",
    Cell: ({ row }) => {
      const o = row.original;
      const nombre = nombreCompleto(o);
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <PersonIcon sx={{ fontSize: 17, color: "#1F618D" }} />
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: "0.83rem" }}>
              {nombre || o.username}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {o.username}
            </Typography>
          </Box>
        </Box>
      );
    },
  },
  {
    accessorKey: "legajo",
    header: "Legajo",
    maxSize: 110,
    Cell: ({ cell }) => cell.getValue() || "-",
  },
  {
    accessorKey: "sucursal",
    header: "Sucursal",
    Cell: ({ cell }) =>
      cell.getValue() ? (
        <Chip label={cell.getValue()} size="small" variant="outlined" />
      ) : (
        "-"
      ),
  },
];
